export default function () {
    const feeds = document.getElementsByClassName("juicer-feed");
    let juicerLoaded = false;
    let juicerInitialized = false;

    // Function to dynamically load the widget resources
    function loadJuicerResources(callback) {
        if (!juicerLoaded) {
            const head = document.getElementsByTagName("head")[0];

            // Create and append the stylesheet
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            link.href = "//assets.juicer.io/embed.css";
            link.onload = () => {
                // Once stylesheet is loaded, load the script
                const script = document.createElement("script");
                script.src = "//assets.juicer.io/embed-no-jquery.js";
                script.defer = true;
                script.onload = () => {
                    //console.log("Juicer widget script loaded");
                    juicerLoaded = true;
                    if (callback) callback(); // Execute the callback after loading
                };
                head.appendChild(script);
            };
            head.appendChild(link);
        } else if (callback) {
            callback(); // Execute the callback immediately if already loaded
        }
    }

    // Function to handle the intersection and initialize the widget
    function handleIntersection(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting && juicerLoaded && !juicerInitialized) {
                //console.log("Juicer widget is initializing now");
                // Perform widget initialization if needed here
                // Example: Initialize or render the widget as needed
                juicerInitialized = true; // Mark as initialized
                observer.unobserve(entry.target); // Stop observing after initialization
            }
        });
    }

    // Initialize Intersection Observer and load resources immediately
    function initializeObserver() {
        loadJuicerResources(() => {
            // Setup the Intersection Observer after the resources are loaded
            if (feeds.length > 0) {
                const observer = new IntersectionObserver(handleIntersection, {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Trigger when 10% of the element is visible
                });

                Array.from(feeds).forEach((feed) => observer.observe(feed));
            } else {
                // If no elements are present, ensure the widget is fully initialized
                if (!juicerInitialized) {
                    /*console.log(
                        "No feeds present, ensuring widget is fully initialized"
                    );*/
                    juicerInitialized = true; // Ensure the widget is considered initialized
                }
            }
        });
    }

    // Run the observer initialization on page load
    window.addEventListener("load", initializeObserver);
}

// export default function () {
//     const feeds = document.getElementsByClassName("juicer-feed");
//     let juicerLoaded = false;

//     // Function to dynamically load the widget resources
//     function loadJuicerResources() {
//         if (!juicerLoaded) {
//             const head = document.getElementsByTagName("head")[0];

//             // Create and append the script
//             const script = document.createElement("script");
//             script.src = "//assets.juicer.io/embed-no-jquery.js";
//             script.defer = true;
//             script.onload = () => {
//                 // Optionally initialize the widget or check if it's ready
//                 console.log("Juicer widget script loaded");
//             };

//             // Create and append the stylesheet
//             const link = document.createElement("link");
//             link.rel = "stylesheet";
//             link.type = "text/css";
//             link.href = "//assets.juicer.io/embed.css";

//             head.appendChild(script);
//             head.appendChild(link);

//             juicerLoaded = true;
//         }
//     }

//     // Function to handle the intersection and loading
//     function handleIntersection(entries, observer) {
//         entries.forEach((entry) => {
//             if (entry.isIntersecting) {
//                 loadJuicerResources();
//                 observer.unobserve(entry.target); // Stop observing after loading
//             }
//         });
//     }

//     // Initialize Intersection Observer
//     function initializeObserver() {
//         if (feeds.length > 0) {
//             const observer = new IntersectionObserver(handleIntersection, {
//                 root: null, // Use the viewport as the root
//                 rootMargin: "0px",
//                 threshold: 0.1, // Trigger when 10% of the element is visible
//             });

//             Array.from(feeds).forEach((feed) => observer.observe(feed));
//         }
//     }

//     // Run the observer initialization on page load
//     window.addEventListener("load", initializeObserver);
// }

// export default function () {
//     const feeds = document.getElementsByClassName('juicer-feed');
//     let juicerLoaded = false;

//     function getOffsetTop(elem) {

//         let offsetTop = 0;
//         do {

//             if (!isNaN(elem.offsetTop)) {

//                 offsetTop += elem.offsetTop;

//             }

//         }
//         while (elem = elem.offsetParent);
//         return offsetTop;

//     }

//     function lazyLoadJuicer() {

//         const juicerFeedScrollDistance = getOffsetTop(feeds[0]);
//         const scrollDistance = window.scrollY;
//         const windowHeight = window.innerHeight;

//         if ((scrollDistance >= (juicerFeedScrollDistance - windowHeight)) && !juicerLoaded) {

//             const head = document.getElementsByTagName('head')[0];
//             const script = document.createElement('script');
//             script.src = '//assets.juicer.io/embed-no-jquery.js';

//             const link = document.createElement('link');
//             link.rel = 'stylesheet';
//             link.type = 'text/css';
//             link.href = '//assets.juicer.io/embed.css';

//             head.appendChild(script);
//             head.appendChild(link);

//             juicerLoaded = true;

//         }

//     }

//     if (feeds && feeds.length > 0) {
//         window.addEventListener('scroll', lazyLoadJuicer);
//         window.addEventListener('load', lazyLoadJuicer);

//         lazyLoadJuicer();
//     }

// }

// /* eslint-disable no-restricted-globals */
// /* eslint-disable no-param-reassign */
// /* eslint-disable no-cond-assign */
// const feeds = document.getElementsByClassName('juicer-feed');
// let juicerLoaded = false;

// function getOffsetTop(elem) {

//     let offsetTop = 0;
//     do {

//         if (!isNaN(elem.offsetTop)) {

//             offsetTop += elem.offsetTop;

//         }

//     }
//     while (elem = elem.offsetParent);
//     return offsetTop;

// }

// function lazyLoadJuicer() {

//     const juicerFeedScrollDistance = getOffsetTop(feeds[0]);
//     const scrollDistance = window.scrollY;
//     const windowHeight = window.innerHeight;

//     if ((scrollDistance >= (juicerFeedScrollDistance - windowHeight)) && !juicerLoaded) {

//         const head = document.getElementsByTagName('head')[0];
//         const script = document.createElement('script');
//         script.src = '//assets.juicer.io/embed-no-jquery.js';

//         const link = document.createElement('link');
//         link.rel = 'stylesheet';
//         link.type = 'text/css';
//         link.href = '//assets.juicer.io/embed.css';

//         head.appendChild(script);
//         head.appendChild(link);

//         juicerLoaded = true;

//     }

// }

// if (feeds && feeds.length > 0) {

//     $(window).on('scroll', lazyLoadJuicer);
//     $(window).on('load', lazyLoadJuicer);
//     lazyLoadJuicer();

// }
